import React from 'react'
import { Button } from '@winnin/winnin_ui.components.button'
import { Title } from '@winnin/winnin_ui.components.title'

import Logo from 'components/Logo'
import Thumbnail from 'components/Thumbnail'
import WidthWrapper from 'components/WidthWrapper'

import IllustrationFallingWoman from '../../../../assets/images/svg/illustration-falling-woman.svg'
import './index.scss'

const ErrorUnauthorized = ({ history, location }) => {
  const goBack = () => {
    if (location?.state?.redirectUrl) {
      return history.push(location?.state?.redirectUrl)
    }
    history.goBack()
  }

  return (
    <div className="error-unauthorized">
      <WidthWrapper>
        <Logo className="header-winnin-logo-unauthorized" />
      </WidthWrapper>
      <WidthWrapper className="wrapper">
        <div className="text">
          <Title className="title" variation="primary" tag="h2">
            You don’t have access to this... yet!
          </Title>
          <Title className="subtitle" tag="h5">
            Upgrade your plan to make the most of our platform&apos;s intelligence!
          </Title>
          <div className="contact">
            <p className="contact-text">For upgrading your plan, contact us at:</p>
            <p className="contact-text email">cs@winnin.com</p>
          </div>
          {location && (
            <Button className="unauthorized-button" onClick={goBack}>
              Take me back
            </Button>
          )}
        </div>
        <Thumbnail className="image" src={IllustrationFallingWoman} />
      </WidthWrapper>
    </div>
  )
}

export default ErrorUnauthorized
